import { currencyFormatter } from "@utils/formatter";

/**
 * A derived Price or Cost as the admin shows it (P1/P2, rulings 2026-10-29):
 * the amount as currency, or null when no live vendor offer prices the
 * product (`hasOffers === false`), whose 0 means "no price" rather than $0.00.
 * Each caller words the null for its own space.
 */
export const derivedAmount = (
    amount: number,
    hasOffers: boolean | undefined,
): string | null =>
    hasOffers === false ? null : currencyFormatter.format(amount);
